import React, { useEffect, useState } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';

const IframePopupPage: React.FC = () => {
  const [iframeUrl, setIframeUrl] = useState<string>('');
  const searchParams = useLocation().search;
  const navigate = useNavigate();

  useEffect(() => {
    const payUrl = new URLSearchParams(searchParams).get('payUrl');
    if (payUrl) {
      setIframeUrl(payUrl);
    }
  }, [searchParams]);

  return (
    <>
      <div className="payverse-wrap">
        <div className="payverse">
          {iframeUrl && (
            <iframe
              id="payment-iframe"
              src={iframeUrl}
              // srcDoc={`
              //   <html>
              //     <body>
              //       <form action="https://shop-stg.eromnet.co.kr/v2/payConfirmResult" method="POST">
              //         <input type="text" name="example" value="test" />
              //         <button type="submit">Submit Form</button>
              //       </form>
              //     </body>
              //   </html>
              // `}
              width="100%"
              height="100%"
              frameBorder="0"
              // onLoad={handleIframeLoad}
            ></iframe>
          )}
        </div>
      </div>
    </>
  );
};

export default IframePopupPage;
